// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".onfido-sdk-ui-RestrictedDocumentSelection-selectionContainer{margin-top:1.5em;text-align:initial}.onfido-sdk-ui-RestrictedDocumentSelection-disabledInput{height:2.375em}.onfido-sdk-ui-RestrictedDocumentSelection-singleCountryInputWrapper{margin-top:.5em}@media(max-width: 479px){.onfido-sdk-ui-RestrictedDocumentSelection-singleCountryInputWrapper{margin-top:0}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal_animation_duration": "200ms",
	"selectionContainer": "onfido-sdk-ui-RestrictedDocumentSelection-selectionContainer",
	"disabledInput": "onfido-sdk-ui-RestrictedDocumentSelection-disabledInput",
	"singleCountryInputWrapper": "onfido-sdk-ui-RestrictedDocumentSelection-singleCountryInputWrapper"
};
export default ___CSS_LOADER_EXPORT___;
